import {NPYLoader} from '../npy-loader';
import {createLoaderWorker} from '@loaders.gl/loader-utils';

createLoaderWorker(NPYLoader);
